/**
 * Detecta se uma URL de avatar é Lottie (animação).
 *
 * Aceita:
 *  - `.lottie` → arquivo dotlottie (zip com manifest + animations).
 *  - `.json` → JSON cru de Bodymovin/Lottie.
 *
 * Ignora query string e fragment (Cloudinary anexa `?v=...` em alguns casos).
 *
 * **Importante:** apenas verificação por extensão. Não baixa o arquivo. Se
 * alguém usar `https://example.com/foo` que serve `application/json`, este
 * helper retorna `false` — preferimos falso negativo (renderiza como img,
 * que falha visualmente óbvio) a falso positivo (tenta parsear PNG como
 * Lottie).
 */

export function isLottieUrl(url: string | null | undefined): boolean {
  if (!url) return false;
  if (url.startsWith("preset:")) return false;
  // Tira query/fragment antes de checar extensão.
  const pathOnly = url.split(/[?#]/, 1)[0]?.toLowerCase() ?? "";
  return pathOnly.endsWith(".lottie") || pathOnly.endsWith(".json");
}
